import { Ajax, addEventSelectorListener } from "@story/story_assets";

addEventSelectorListener.call(document, "click", "a[href][data-remote='true']", function(event, target) {
	event.preventDefault();
	let href = target.getAttribute("href");

	Ajax.get(href);
	window.history.pushState({}, "", href);
});
